'use client';
import React from 'react';
import { Link } from '@/shared/components/primitives/link';
import { useUser } from '@/features/auth/shared/hooks/use-user';
import { useTranslations } from 'next-intl';
import { cn } from '@ecom/helper-react-class-combine';
import { pagesRoutes } from '@/shared/constants/routes';

export default function WildMembershipBanner({ className }: { className?: string }) {
  const { authenticatedUser } = useUser();
  const t = useTranslations('Home.joinWildBanner');
  if (authenticatedUser && authenticatedUser.isWildMember) return <></>;

  return (
    <Link
      href={pagesRoutes.joinWild.href}
      className={cn(
        `relative block w-full rounded-xl bg-linear-to-r from-fuchsia-600 via-rose-500 to-orange-400 px-6 py-8 shadow-md transition-shadow duration-300 hover:shadow-[0_0_25px_rgba(244,63,94,0.1),0_0_40px_rgba(192,38,211,0.3)] focus:ring-2 focus:ring-white/50 focus:outline-hidden`,
        className,
      )}
      data-gtm='cta'
      data-cta-name='home-page-banner'
    >
      <div className='grid grid-cols-1 items-center gap-6 text-white md:grid-cols-4'>
        <h2 className='col-span-1 text-2xl font-bold sm:text-3xl'>{t('title')}</h2>

        <p className='col-span-2 text-center text-3xl sm:text-4xl'>
          {t('middleText.1')} <span className='font-extrabold'>{t('middleText.2')}</span>
        </p>

        <span className='col-span-1 inline-flex items-center justify-center rounded-lg bg-sky-600 px-8 py-4 text-lg font-semibold text-white transition-colors hover:bg-sky-500'>
          {t('buttonText')}
        </span>
      </div>
    </Link>
  );
}
